import React, { SelectHTMLAttributes } from 'react';
import { FieldLabel } from './FieldLabel';

export type SelectOption = { value: string; label: string };

export type SelectInputProps = {
  label?: string;
  options: SelectOption[];
  placeholderLabel?: string;
  containerClassName?: string;
} & SelectHTMLAttributes<HTMLSelectElement>;

export function SelectInput({
  label,
  options,
  placeholderLabel = 'Select...',
  containerClassName,
  className,
  value,
  ...rest
}: SelectInputProps) {
  const showPlaceholder = (value ?? '') === '';

  return (
    <label className={['block space-y-2', containerClassName].filter(Boolean).join(' ')}>
      {label && <FieldLabel>{label}</FieldLabel>}

      <select
        value={value}
        className={[
          'w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white font-montserrat',
          'focus:outline-none focus:ring-2 focus:ring-[#ff8a4a]/60 focus:border-[#ff8a4a]/60 transition-all',
          className || ''
        ].join(' ')}
        {...rest}
      >
        {showPlaceholder && (
          <option value="" disabled hidden className="bg-[#0f1c2e]">
            {placeholderLabel}
          </option>
        )}

        {options.map(o => (
          <option key={o.value} value={o.value} className="bg-[#0f1c2e]">
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
